module.exports = __webpack_public_path__ + "img/cabal.d05062bb.svg";